module.exports = __webpack_public_path__ + "img/mag-2.1c2c3b86.jpg";